import { render, staticRenderFns } from "./week-page.vue?vue&type=template&id=79eb5b7a"
import script from "./week-page.vue?vue&type=script&lang=js"
export * from "./week-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports